// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"96":"vendors","792":"main"}[chunkId] + "." + {"96":"c222c4f7d5991d977761","792":"a453acfb267d575299f2"}[chunkId] + ".css";
};